import { useRouteError, isRouteErrorResponse } from 'react-router'

export function ErrorBoundary() {
    const error = useRouteError()

    if (isRouteErrorResponse(error)) {
        return (
            <div className='error-boundary'>
                <h2>Oops! Something went wrong</h2>
                <p>
                    <i>
                        {error.status} {error.statusText}
                    </i>
                </p>
                {error.data && <p>{error.data}</p>}
            </div>
        )
    }

    return (
        <div className='error-boundary'>
            <h2>Oops! Something went wrong</h2>
            <p>
                <i>
                    {error instanceof Error
                        ? error.message
                        : 'An unexpected error occurred'}
                </i>
            </p>
        </div>
    )
}
